<script>
    export default {
        props: {
            role: Object,
        },
        methods: {
            async selectRole() {
                this.$store.commit('ROLE_EDIT_SET', this.role);
                this.$store.dispatch('CHECK_ROLE_EDIT');
                this.$store.commit('IS_SHOW_ROLE_EDIT', true);
            }
        }
    }
</script>


<template>
    <li
        @click="selectRole"
    >
        <div 
            class="blur_white cursor_pointer_label"
        >
            <label>[{{ role['id'] }}]</label>
            <label class="ml_5">{{ role['name'] }}</label>
        </div>
    </li>
</template>